/**
 * @generated SignedSource<<5732d69ee599df16d88f3e5f4d2761b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleTopicFollowWidgetArticle$data = {
  readonly topics: ReadonlyArray<{
    readonly disableFollow: boolean | null | undefined;
    readonly entityId: string;
    readonly " $fragmentSpreads": FragmentRefs<"entityFollowButtonBase" | "topicLinkTopic">;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "articleTopicFollowWidgetArticle";
};
export type articleTopicFollowWidgetArticle$key = {
  readonly " $data"?: articleTopicFollowWidgetArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleTopicFollowWidgetArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleTopicFollowWidgetArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Topic",
      "kind": "LinkedField",
      "name": "topics",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "topicLinkTopic"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "entityFollowButtonBase"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "disableFollow",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "47cbae88e85e2b303712dec4e30de590";

export default node;
